<header-share class="no_menu"></header-share>

<main class="wrap">
  <div class="con">
    <h2>회원가입</h2>

    <form [formGroup]="form" action="">
      <fieldset>
        <legend>가입정보 입력</legend>
        <div class="id_box">
          <p class="input_wrap">
            <label for="uid">아이디</label>
            <span class="input_box">
              <input
                id="uid"
                name="uid"
                class="uid"
                minlength="5"
                maxlength="10"
                [(ngModel)]="account.id"
                formControlName="id"
                (keyup)="onkey($event)"
              />
              <button class="id_check" (click)="checkId(account.id)">
                중복확인
              </button></span
            >
            <span class="notice_txt"
              >(영문 또는 영문+숫자를 이용한 5~10자리)</span
            >
          </p>
          <p
            class="vdt"
            *ngIf="
              form.controls.id.dirty && !form.controls.id.valid && !alreadyId
            "
          >
            입력형식에 맞춰 다시 입력해 주세요.
          </p>
          <p class="vdt" *ngIf="account.id && alreadyId">
            이미 사용 중인 아이디입니다. 다른 아이디를 입력해 주세요.
          </p>
          <p
            class="vdt"
            *ngIf="
              account.id && form.controls.id.valid && !idChecked && !alreadyId
            "
          >
            아이디 중복 확인을 해주세요.
          </p>
        </div>

        <div class="input_area">
          <p class="input_wrap">
            <label for="pwd" maxlength="15">비밀번호</label>
            <input
              type="password"
              id="pwd"
              name="pwd"
              class="pwd"
              minlength="6"
              maxlength="15"
              [(ngModel)]="account.password"
              formControlName="password"
            />
            <span class="notice_txt"
              >(영문, 숫자, 특수문자를 이용한 6~15자리)</span
            >
          </p>
          <p
            class="vdt"
            *ngIf="!form.controls.password.dirty && account.password.length > 0"
          >
            비밀번호를 입력해주세요.
          </p>
          <p
            class="vdt"
            *ngIf="
              !form.controls.password.valid && form.controls.password.dirty
            "
          >
            입력형식에 맞춰 다시 입력해 주세요.
          </p>
        </div>

        <div class="input_area">
          <p class="input_wrap">
            <label for="repwd" maxlength="15">비밀번호 확인</label>
            <input
              type="password"
              id="repwd"
              name="repwd"
              class="repwd"
              [(ngModel)]="account.confirmPassword"
              formControlName="confirmPassword"
            />
          </p>
          <p
            class="vdt"
            *ngIf="
              !form.controls.confirmPassword.dirty &&
              account.confirmPassword.length > 0
            "
          >
            비밀번호 확인을 입력해주세요.
          </p>
          <p
            class="vdt"
            *ngIf="
              form.controls.confirmPassword.touched &&
              form.hasError('mismatchedPasswords') &&
              form.controls.password.valid
            "
          >
            비밀번호가 일치하지 않습니다. 비밀번호를 다시 확인해주세요.
          </p>
        </div>
      </fieldset>

      <fieldset>
        <legend>회원정보 입력</legend>
        <div class="input_area">
          <p class="input_wrap">
            <label for="uname">이름</label>
            <input
              type="text"
              name="uname"
              id="uname"
              class="uname"
              placeholder="홍길동"
              minlength="1"
              maxlength="7"
              [(ngModel)]="account.name"
              formControlName="name"
            />
            <span class="notice_txt">(실명을 입력해 주세요.)</span>
          </p>
          <p class="vdt" *ngIf="account.name.length == 0">
            이름을 입력해주세요.
          </p>
        </div>
        <div class="input_area">
          <p class="input_wrap">
            <label for="uname">학교</label>
            <input
              type="text"
              name="uname"
              id="uname"
              class="uname"
              placeholder="한국중학교"
              maxlength="10"
              [(ngModel)]="account.school"
              [ngModelOptions]="{ standalone: true }"
            />
            <span class="notice_area">
              <span class="notice_txt txt1"
                >(초등학교 혹은 중학교까지 입력해주세요.)</span
              >
              <span class="notice_txt">(예-한국초등학교혹은 한국중학교)</span>
            </span>
          </p>
          <p class="vdt" *ngIf="!account.school">학교를 입력해주세요</p>
        </div>

        <div class="input_area select_area">
          <p class="input_wrap">
            <label for="schoolyear">학년</label>
            <select
              name="schoolyear"
              id="schoolyear"
              class="schoolyear"
              [(ngModel)]="account.grade"
              [ngClass]="{ placeholder: account.grade == 'placeholder' }"
              [ngModelOptions]="{ standalone: true }"
            >
              <!--placeholder 대체 option-->
              <option value="placeholder" disabled selected hidden>
                학년선택
              </option>
              <option *ngFor="let item of schoolYear" [value]="item">
                {{ item }}
              </option>
            </select>
          </p>
          <p class="vdt" *ngIf="account.grade == 'placeholder'">
            학년을 입력해주세요
          </p>
        </div>

        <div class="input_area select_area">
          <p class="input_wrap">
            <label for="schoolyear">지역</label>
            <select
              name="schoolArea"
              id="schoolArea"
              class="schoolArea"
              [(ngModel)]="account.region"
              [ngClass]="{ placeholder: account.region == 'placeholder' }"
              [ngModelOptions]="{ standalone: true }"
            >
              <!--placeholder 대체 option-->
              <option value="placeholder" disabled selected hidden>
                지역선택
              </option>
              <option *ngFor="let item of schoolArea" [value]="item">
                {{ item }}
              </option>
            </select>
          </p>
          <p class="vdt" *ngIf="account.region == 'placeholder'">
            지역을 입력해주세요
          </p>
        </div>

        <div class="input_area">
          <div class="input_wrap gender_box">
            <p class="gender_title">성별</p>

            <input
              type="radio"
              name="gender"
              value="male"
              (click)="genderCheck($event)"
              id="male"
              [checked]="account.gender == 'male' ? true : false"
            />
            <label for="male" class="radio_label"><span>남자</span></label>
            <input
              type="radio"
              name="gender"
              value="female"
              id="female"
              (click)="genderCheck($event)"
              [checked]="account.gender == 'female' ? true : false"
            />
            <label for="female" class="radio_label"><span>여자</span></label>
          </div>
          <p class="vdt" *ngIf="!account.gender">성별을 선택해주세요.</p>
        </div>

        <div class="input_area">
          <p class="input_wrap">
            <label for="teacherCode">선생님 코드</label>
            <input
              type="text"
              name="teacherCode"
              id="teacherCode"
              class="teacher_code"
              maxlength="8"
              [(ngModel)]="account.teacherCode"
              [ngModelOptions]="{ standalone: true }"
            />
            <span class="notice_txt"
              >(담당 선생님의 코드를 입력해 주세요.)</span
            >
          </p>
          <p class="vdt" *ngIf="!account.teacherCode">코드를 확인해주세요.</p>
        </div>
      </fieldset>

      <fieldset>
        <div class="agree_wrap">
          <legend>정보수집 동의</legend>
          <div class="all_wrap">
            <input
              type="checkbox"
              name="all"
              value="all"
              id="all"
              [(ngModel)]="agreeAllTerms"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="checkAgreeeAll(0)"
            /><label for="all"><span>전체동의</span></label>
          </div>
          <p class="ck_box">
            <input
              type="checkbox"
              name="service"
              value="service"
              id="service"
              [(ngModel)]="account.serviceTerms"
              (ngModelChange)="checkAgreeeAll(1)"
              formControlName="serviceTerms"
            /><label for="service"
              ><span>서비스 이용약관 동의 (필수)</span></label
            ><button (click)="openPersonal('serviceTerm')">내용보기</button>
          </p>
          <p class="ck_box">
            <input
              type="checkbox"
              name="personal"
              value="personal"
              id="personal"
              [(ngModel)]="account.personalInfo"
              (ngModelChange)="checkAgreeeAll(2)"
              formControlName="personalInfo"
            /><label for="personal"
              ><span>개인정보수집 및 이용 동의 (필수)</span></label
            ><button (click)="openPersonal('privacy')">내용보기</button>
          </p>

          <p
            class="vdt"
            *ngIf="
              !form.controls.serviceTerms.valid ||
              !form.controls.personalInfo.valid
            "
          >
            정보수집에 동의해주세요.
          </p>
        </div>
      </fieldset>

      <button class="save_btn" [disabled]="!form.valid" (click)="register()">
        회원가입
      </button>
      <!-- <button class="save_btn" (click)="register()">회원가입</button> -->
    </form>
  </div>
</main>

<footer-share></footer-share>
